// extracted by mini-css-extract-plugin
export default {"wrap-container":"UserDetails_wrap-container__UJIrA"};